import { css } from '@emotion/react';
export const isHtmlNode = (type) => {
    return typeof type === 'string';
};
const blockNodes = new Set([
    'address',
    'article',
    'aside',
    'blockquote',
    'details',
    'dialog',
    'dd',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'header',
    'hgroup',
    'hr',
    'li',
    'main',
    'nav',
    'ol',
    'p',
    'pre',
    'section',
    'table',
    'ul',
]);
export const isBlockNode = (type) => {
    return blockNodes.has(type);
};
const svgNodes = new Set([
    'path',
    'rect',
    'ellipse',
    'circle',
    'g',
    'defs',
    'clipPath',
    'linearGradient',
    'stop',
    'animate',
]);
export const isSvgNode = (type) => {
    return svgNodes.has(type);
};
const clickableNodes = new Set(['a', 'label', 'button']);
export const isClickableNode = (type) => {
    return clickableNodes.has(type);
};
export const buildResetStyles = (nodeType) => {
    return css `
    all: unset;
    box-sizing: border-box;
    /* Fix Safari 13 issue with 'color' and 'all: unset'
     * (https://bugs.webkit.org/show_bug.cgi?id=158782).
     */
    -webkit-text-fill-color: currentColor;
    /* Fix Firefox textarea issue with 'all: unset' */
    ${nodeType === 'textarea' ? 'white-space: pre-wrap;' : ''}
    ${nodeType === 'strong' ? 'font-weight: bold;' : ''}
    ${nodeType === 'em' ? 'font-style: italic;' : ''}
    ${isBlockNode(nodeType) ? 'display: block;' : ''}
    ${isClickableNode(nodeType) ? 'cursor: pointer;' : ''}
  `;
};
//# sourceMappingURL=buildResetStyles.js.map
// @zapier/style-encapsulation@1.3.0 (e31aef2e9)
